export default __webpack_public_path__ + "static/media/HypoLake.87a12fc6.svg";